const Side = {
  LEFT: 'left',
  RIGHT: 'right'
}

export default Side;